import { useMemo } from 'react';
export const useIsHidden = ({ option, removable, selectedValues, }) => {
    const isHidden = useMemo(() => !removable || (option && selectedValues?.some((value) => value == option.value)), [removable, selectedValues, option]);
    return isHidden;
};
